import b from 'b_';
import React, { ComponentProps } from 'react';
import cx from 'classnames';

import './students__accepted-icon.scss';

const AcceptedIcon = ({ className, ...props }: Omit<ComponentProps<'svg'>, 'viewBox' | 'height' | 'width'>) => (
    <svg {...props} className={cx(b('students', 'accepted-icon'), className)} height="8" viewBox="0 0 12 8" width="12">
        <path
            d="M1.833 3.964L4.84 7l5.994-6"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
        />
    </svg>
);

export default AcceptedIcon;
